export default "__VITE_ASSET__5019747e__"